import { render, staticRenderFns } from "./requisition.vue?vue&type=template&id=07f70a3b"
import script from "./requisition.vue?vue&type=script&lang=js"
export * from "./requisition.vue?vue&type=script&lang=js"
import style0 from "./requisition.vue?vue&type=style&index=0&id=07f70a3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports